
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{staticClass:"a",attrs:{"transform":"translate(1247 37)","d":"M0 0h20v20H0z"}})])]),_c('g',{staticClass:"b",attrs:{"transform":"translate(-1247 -37)","clip-path":"url(#a)"}},[_c('path',{staticClass:"c",attrs:{"d":"M1255.125 56h-5.937a1.194 1.194 0 01-1.188-1.2V42.2a1.194 1.194 0 011.188-1.2h2.968a2.969 2.969 0 115.938 0h2.969a1.194 1.194 0 011.188 1.2V44","fill":"none","stroke":"rgba(61,61,61,.78)","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.25"}}),_c('path',{staticClass:"c",attrs:{"d":"M1255.202 40.5a.312.312 0 11-.312.312.312.312 0 01.312-.312m.799 10.501a5 5 0 105-5 5 5 0 00-5 5z","fill":"none","stroke":"rgba(61,61,61,.78)","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.25"}}),_c('path',{staticClass:"c",attrs:{"d":"M1263.229 49.692l-2.421 3.228a.626.626 0 01-.942.067l-1.25-1.25","fill":"none","stroke":"rgba(61,61,61,.78)","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.25"}})])])
          )
        }
      }
    